import React from 'react';
import { Interview } from '../../../../entities/Interview';
import { IconSpan } from '../../../../components/IconSpan';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { Card } from 'reactstrap';
import { CopyButton } from '../../../../components/CopyButton';

interface PropTypes {
  interview: Interview;
}

export function ScorecardSummary(props: PropTypes) {
  return (
    <div className={styles.header}>
      <div className='d-flex justify-content-between mx-2'>
        <IconSpan
          className='fs-6'
          spanText='Summary generated with Screenloop AI'
          icon={{ className: 'text-dark-500', name: 'bi-stars' }}
        />
        <CopyButton textToBeCopied={props.interview.summary} />
      </div>
      <Card
        className={classNames(
          'mt-2',
          'bg-gray',
          'p-3',
          'rounded-2',
          'h-100',
          'fs-5',
          styles.container,
        )}
      >
        <div>{props.interview.summary}</div>
      </Card>
    </div>
  );
}
